import { Component, OnInit } from "@angular/core";
import { LocalServiceService } from "../../shareModule/services/local-service.service";

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {

    constructor(
        private local: LocalServiceService,
    ) { }


    ngOnInit() {

    }

    ngOnDestroy(): void {
        // Clear all intervals
    }

}